import { swSettings } from "app/common/services/swSettings";

export const VISUAL_DATE_FORMAT = "D, MMM YYYY";
export enum EGranularities {
    DAILY = "Daily",
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
}

export enum EStores {
    Google = "0",
    Apple = "1",
}

export enum EndpointType {
    TABLE = "Table",
    EXCEL = "Excel",
    GRAPH = "Graph",
    DATA = "Data",
}

export const GOOGLE_STORE = "Google";
export const APPLE_STORE = "Apple";

// sales-intelligence states
export enum AppStoreName {
    APPLE = "Apple",
    GOOGLE = "Google",
}

export const getAppCategoryStore = (store?: string | null) => {
    const APP_CATEGORY_ANALYSIS_URL = swSettings.swsites.apps + "/market-analysis/top-charts/";
    const appCategoryStore: string = store?.toLowerCase() || AppStoreName?.GOOGLE?.toLowerCase();
    return APP_CATEGORY_ANALYSIS_URL + `${appCategoryStore}`;
};
export enum AppStoreID {
    APPLE = "1",
    GOOGLE = "0",
}

export const appStoreNameToIDMap = {
    [AppStoreName.APPLE]: AppStoreID.APPLE,
    [AppStoreName.GOOGLE]: AppStoreID.GOOGLE,
};
